
import Request from './reqeust';

//用户信息
export function detailInfo(_params) {
    return Request({
        url: '/api/account-center/detail-info',
        method: 'get',
        params: _params
    })
}

// 轮播图
export function banners(_params) {
    return Request({
        url: '/pc/home/banner/'+_params,
        method: 'get',
    })
}

// 检测当前用户是否绑卡
export function isOnlineBankingBinding() {
    return Request({
        url: '/api/select-user-permission/isOnlineBankingBinding',
        method: 'get',
    })
}

//局列表
export function bureauList() {
    return Request({
        url: '/api/bureau-stand/bureau-list',
        method: 'get',
    })
}

//是否能贸易下单
export function isTrade(_params) {
    return Request({
        url: '/api/select-user-permission/isTrade/'+_params,
        method: 'get',
        params: {}
    })
}

//是否能物流发货
export function verifyDelivery(_params) {
    return Request({
        url: '/api/select-user-permission/verifyDelivery',
        method: 'get',
        params: _params
    })
}

//是否能物流订单报价
export function isLogistics(_params) {
    return Request({
        url: '/api/select-user-permission/isLogistics',
        method: 'get',
        params: _params
    })
}

//是否能汽运订单报价
export function isTrucks(_params) {
    return Request({
        url: '/api/select-user-permission/isTrucks',
        method: 'get',
        params: _params
    })
}

//是否能汽运订单发货
export function verifyTrucksOffer(_params) {
    return Request({
        url: '/api/select-user-permission/verifyTrucksOffer',
        method: 'get',
        params: _params
    })
}

//检测售价/收购权限
export function verifyReleaseProduct(_params) {
    return Request({
        url: '/api/select-user-permission/verifyReleaseProduct',
        method: 'get',
        params: _params
    })
}

//检测发布权限
export function verifySupply(_params) {
    return Request({
        url: '/api/select-user-permission/verifySupply',
        method: 'get',
        params: _params
    })
}
// export function getAgreementByCode(_code) {
//     return Request({
//         url: 'pc/the-text/getContent/'+_code,
//         method: 'get',
//         params: {}
//     })
// }

//首页
export function homTopView(_params) {
    return Request({
        url: 'pc/home/view',
        method: 'get',
        params: _params
    })
}

//今日售价
export function todaySales(_params) {
    return Request({
        url: 'pc/home/nowDataPrice',
        method: 'get',
        params: _params
    })
}

//今日收购价
export function todayAcquisitions(_params) {
    return Request({
        url: 'pc/home/nowDataPurchase',
        method: 'get',
        params: _params
    })
}

//视频销售
export function marketVideos(_params) {
    return Request({
        url: 'pc/home/marketVideo',
        method: 'get',
        params: _params
    })
}

//企业门店列表
export function storeList(_params) {
    return Request({
        url: 'pc/home/store-list',
        method: 'get',
        params: _params
    })
}

//本站货主列表
export function shipperList(_params) {
    return Request({
        url: 'api/index/shipperList',
        method: 'get',
        params: _params
    })
}

//公告通知
export function announcementList(_params) {
    return Request({
        url: 'pc/home/announcement-list',
        method: 'get',
        params: _params
    })
}

//需求列表
export function getDemands(_params) {
    return Request({
        url: 'pc/home/now-stand-supply-and-demand-view',
        method: 'get',
        params: _params
    })
}

//公告通知详情
export function announcementInfo(_id) {
    return Request({
        url: 'pc/home/announcementInfo/'+_id,
        method: 'get',
        params: {}
    })
}

//搜索站
export function searchStand(_params) {
    return Request({
        url: 'api/bureau-stand/searchStand',
        method: 'get',
        params: _params
    })
}


//获取铁路规格
export function getRailwayMeasures(_params) {
    return Request({
        url: 'api/order/getRailwayMeasures',
        method: 'get',
        params: _params
    })
}

//获取产品类别
export function getProductCates() {
    return Request({
        url: 'api/release-product/getProductClassList',
        method: 'get',
        params: {}
    })
}

//发布需求
export function releaseSupplyDemand(_params) {
    return Request({
        url: 'api/index/releaseSupplyDemand',
        method: 'post',
        params: _params
    })
}

//获取条款协议
export function getAgreementByCode(_code) {
    return Request({
        url: 'pc/the-text/getContent/'+_code,
        method: 'get',
        params: {}
    })
}

//今日售价详情
export function todayPriceDetailedInfo(_id) {
    return Request({
        url: 'api/release-product/todayPriceDetailedInfo',
        method: 'get',
        params: {releaseProductId:_id}
    })
}

//今日收购价详情
export function todayPurchaseDetailedInfo(_id) {
    return Request({
        url: 'api/release-product/todayPurchaseDetailedInfo',
        method: 'get',
        params: {releaseProductId:_id}
    })
}

//汽运发货
export function publishLgisticsDeliveryTruck(_params) {
    return Request({
        url: 'api/order/LogisticsDeliveryTruck',
        method: 'post',
        params: _params
    })
}

//物流发货
export function publishLogisticsDelivery(_params) {
    return Request({
        url: 'api/order/logisticsDelivery',
        method: 'post',
        params: _params
    })
}

//货车司机列表
export function getDriverDataList(_params) {
    return Request({
        url: 'pc/order/getDriverDataList',
        method: 'get',
        params: _params
    })
}

//视频详情
export function videoInfo(_id) {
    return Request({
        url: 'api/market-video/videoInfo',
        method: 'get',
        params: {marketingVideoId:_id}
    })
}

//投保
export function insured(_params) {
    return Request({
        url: 'api/order/insured',
        method: 'post',
        params: _params
    })
}

//添加今日售价
export function addTodayPrice(_params) {
    return Request({
        url: 'api/release-product/addTodayPrice',
        method: 'post',
        params: _params
    })
}

//添加今日收购
export function addTodayPurchase(_params) {
    return Request({
        url: 'api/release-product/addTodayPurchase',
        method: 'post',
        params: _params
    })
}

//获取货物类型
export function getTransportGoods() {
    return Request({
        url: 'api/order/getTransportGoods',
        method: 'get',
        params: {}
    })
}

//获取费率
export function getTransportRate(_params) {
    return Request({
        url: 'api/order/getTransportRate',
        method: 'get',
        params:_params
    })
}

//同步发票信息
export function syncUserInvoice(_params) {
    return Request({
        url: 'api/account-center/syncUserInvoice',
        method: 'post',
        params:_params
    })
}

//获取询价物流公司
export function getOfferLogisticsCompany(_deliveryStandId,_arrivalStandId, _deliveryWay) {
    return Request({
        url: 'api/order/getOfferLogisticsCompany',
        method: 'get',
        params:{deliveryStandId:_deliveryStandId,arrivalStandId:_arrivalStandId, deliveryWay: _deliveryWay}
    })
}


//发布视频
export function releaseVideo(_params) {
    return Request({
        url: 'api/market-video/releaseVideo',
        method: 'post',
        params:_params
    })
}


//获取七牛token
export function generateQiniuUploadToken() {
    return Request({
        url: 'api/market-video/generateQiniuUploadToken',
        method: 'get',
        params:{}
    })
}


//获取重置密码验证码
export function reqResetPassSMS(_params) {
    return Request({
        url: 'api/account/reqResetPassSMS',
        method: 'get',
        params:_params
    })
}


//获取重置密码
export function resetPass(_params) {
    return Request({
        url: 'api/account/resetPass',
        method: 'post',
        params:_params
    })
}


//获取物流供需
export function getWlgxList(_params) {
    return Request({
        url: 'pc/home/now-stand-supply-and-demand-view',
        method: 'get',
        params:_params
    })
}


//获取重置密码
export function getLogisticsSupplyAndDemandInfo(_id) {
    return Request({
        url: 'pc/home/getLogisticsSupplyAndDemandInfo/'+_id,
        method: 'get',
        params:{id:_id}
    })
}


//获取企业详情
export function getCompanyInfo(_id) {
    return Request({
        url: 'api/company-details/info',
        method: 'get',
        params:{companyId:_id}
    })
}


//今日收购价上下架
export function todayBuyOnTheShelves(_params) {
    return Request({
        url: 'pc/account-center/todayBuyOnTheShelves',
        method: 'post',
        params:_params
    })
}

//今日售价上下架
export function todayPriceOnTheShelves(_params) {
    return Request({
        url: 'pc/account-center/todayPriceOnTheShelves',
        method: 'post',
        params:_params
    })
}

//汽运详情
export function logisticsDeliveryTrucksDetailsInfo(_id) {
    return Request({
        url: 'api/order/logisticsDeliveryTrucksDetailsInfo',
        method: 'get',
        params:{logisticsTrucksId:_id}
    })
}

//举报
export function report(_params) {
    return Request({
        url: 'api/company-details/report',
        method: 'post',
        params:_params
    })
}

//视频收藏
export function collectVideo(_params) {
    return Request({
        url: 'api/market-video/videoCollect',
        method: 'get',
        params:_params
    })
}

//获取小程序二维码
export function generateMiniJoinQrCode(_userId) {
    return Request({
        url: 'api/enter/generateMiniJoinQrCode/'+_userId,
        method: 'get',
        params:{}
    })
}

//提交反馈
export function submitFeedbackAdvice(_params) {
    return Request({
        url: 'pc/home/submitFeedbackAdvice',
        method: 'post',
        params:_params
    })
}

//获取登录二维码
export function createdOrCode() {
    return Request({
        url: 'api/account/createdOrCode',
        method: 'get',
        params:{}
    })
}

//二维码登录
export function orCodeLogin(_orCodeLogo) {
    return Request({
        url: 'api/account/orCodeLogin',
        method: 'get',
        params:{orCodeLogo:_orCodeLogo}
    })
}

//获取sig
export function getImUserSig() {
    return Request({
        url: 'api/account-center/getImUserSig',
        method: 'get',
        params:{}
    })
}

//模糊搜索公司名称
export function selectCompanyName(_name) {
    return Request({
        url: 'api/enter/selectCompanyName',
        method: 'get',
        params:{companyName:_name}
    })
}
//模糊搜索支行名称
export function selectZhihang(_params) {
    return Request({
        url: '/api/union-pay-certification/branchBankList',
        method: 'get',
        params:_params
    })
}


//查询订单状态
export function getUnionPayOrder(_orderNo) {
    return Request({
        url: 'api/order-call-back/getUnionPayOrder',
        method: 'get',
        params:{orderNo:_orderNo}
    })
}

//api/order-call-back/getUnionPayOrder

//api/enter/selectCompanyName

//api/account-center/getImUserSig



// WEBPACK FOOTER //
// ./src/services/index.js